module.exports = __webpack_public_path__ + "img/axe-battle.ccd13d6d.svg";